import React from "react";
import Support from "../Shared/Svgs/Support";
import ToolTip from "../ToolTip/ToolTip";

const SupportButton = () => {
    return (
        <div className="SupportButton ToolTipParent">
            <ToolTip message="Support" showAbove={true} />
            <Support />
        </div>
    );
};

export default SupportButton;
